import { STABLE_EMPTY_OBJECT } from '@feedyou/utils'
import { StepTypeDefaults } from '@feedyou/schema/dist/typescript/botFlow'

import { botFlowSelector } from './botFlowSelector'
import { RootState } from '../../../reducers'

export const stepTypeDefaultsSelector = (state: RootState): StepTypeDefaults => {
  return botFlowSelector(state)?.stepTypeDefaults ?? STABLE_EMPTY_OBJECT
}
